module.exports = __webpack_public_path__ + "static/media/14.b2a6861b.jpg";